import Moment from "react-moment";
import { COUNTRY_LIST, Helper } from "../../utils";

const ViewBasicLoginConfig = ({ data }) => {
    const {
        basicAuthPath,
        isEnabled,
        appName,
        country,
        forogtPasswordPath,
        resetPasswordPath,
        changePasswordPath,
        createdAt,
        rootPath,
        domainName,
    } = data;

    return (
        <>
            <h5 className="tab-pane__title">Basic Login Information</h5>
            <div className="info-table">
                <div className="row info-table__tr mb-2">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">App Domain</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{domainName}</strong>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Basic Login Path</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{basicAuthPath}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-table__tr mb-2">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Basic Login Root Path</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{rootPath}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Forgot Password Path</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{forogtPasswordPath}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-table__tr mb-2">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Reset Password Path</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{resetPasswordPath}</strong>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Change Password Path</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{changePasswordPath}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-table__tr mb-2">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">App Name</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{Helper.getAppNameById(appName)}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Country</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{COUNTRY_LIST[country]}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-table__tr mb-2">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Create Date</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>
                                        <Moment format="MMM DD, YYYY HH:mm">{createdAt}</Moment>
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Enabled</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{Number(isEnabled) === 1 ? "Yes" : "No"}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewBasicLoginConfig;
